<template>
    <div class="bigdata_title" id="bigdata">
        <!-- <div class="header">
      <h1 >{{this.$store.state.info.orgName}}时间银行可视化</h1>
    </div> -->
        <div class="customerTop">
            <img src="../assets/img/bedstop.png" alt="" srcset="" />
            <div class="titleFirst"></div>
            <div class="titleSecond"></div>
            <h1>{{ this.$store.state.info.orgName }}家庭床位可视化</h1>
        </div>
        <div class="quanp">
            <el-button id="fullScreen" @click="showFullScreen" type="primary">{{
                onFullScreen ? "退出全屏" : "进入全屏"
            }}</el-button>
        </div>
        <!-- <div class="quanpL">
            <el-button id="fullScreen" @click="refreshMap" type="primary">
                刷新地图
            </el-button>
        </div> -->
        <div class="content1">
            <div class="content1-title">
                <div class="title-left1 img2">
                    <div class="left1-title1-1">服务人员管理</div>
                    <div class="left1-title1-21">
                        <div>
                            <div style="display: flex; line-height: 20px">
                                <div style="font-size: 20px; margin-left: 5px">
                                    {{ servising }}
                                </div>
                                <div style="font-size: 12px">（人）</div>
                            </div>
                            <div class="left1-bottom1">总人数</div>
                        </div>
                        <div @click="lookupSerPer()" style="margin-right: 4px">
                            <div style="display: flex; line-height: 20px">
                                <div style="font-size: 20px; margin-left: 5px">
                                    {{ service }}
                                </div>
                                <div style="font-size: 12px">（人）</div>
                            </div>
                            <div
                                class="left1-bottom1 serviceing"
                                @click="showDialog"
                            >
                                服务中
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="title-left1 img1"
                    @click="getAll"
                    style="cursor: pointer"
                >
                    <div class="left1-title1-1">服务总数</div>
                    <!-- <div
            class="left1-title1-2"
            style="margin-top: 8%"
          >
            <div style="font-size: 20px">{{ tatolOldlist }}</div>
            <div style="font-size: 12px">（人）</div>
          </div> -->
                    <div class="left1-title1-21">
                        <div>
                            <div style="display: flex; line-height: 20px">
                                <div style="font-size: 20px; margin-left: 5px">
                                    50
                                </div>
                                <div style="font-size: 12px">（条）</div>
                            </div>
                            <div class="left1-bottom1">政府购买</div>
                        </div>
                        <div @click="lookupSerPer()" style="margin-right: 4px">
                            <div style="display: flex; line-height: 20px">
                                <div style="font-size: 20px; margin-left: 5px">
                                    50
                                </div>
                                <div style="font-size: 12px">（条）</div>
                            </div>
                            <div class="left1-bottom1 serviceing">社会自费</div>
                        </div>
                    </div>
                </div>
                <div class="title-left1 img3">
                    <div class="left1-title1-1">服务工单总数</div>
                    <!-- <div
            class="left1-title1-2"
            style="margin-top: 8%"
          >
            <div style="font-size: 20px">{{ serviceOrder }}</div>
            <div style="font-size: 12px">（次）</div>
          </div> -->
                    <div class="left1-title1-21">
                        <div>
                            <div style="display: flex; line-height: 20px">
                                <div style="font-size: 20px; margin-left: 5px">
                                    50
                                </div>
                                <div style="font-size: 12px">（次）</div>
                            </div>
                            <div class="left1-bottom1">计划工单</div>
                        </div>
                        <div @click="lookupSerPer()" style="margin-right: 4px">
                            <div style="display: flex; line-height: 20px">
                                <div style="font-size: 20px; margin-left: 5px">
                                    50
                                </div>
                                <div style="font-size: 12px">（次）</div>
                            </div>
                            <div class="left1-bottom1 serviceing">已完成</div>
                        </div>
                    </div>
                </div>

                <div class="title-left1 img4">
                    <div class="left1-title1-1">应急工单总数</div>
                    <div class="left1-title1-21">
                        <div>
                            <div style="display: flex; line-height: 20px">
                                <div style="font-size: 20px; margin-left: 5px">
                                    {{ this.alarmCount }}
                                </div>
                                <div style="font-size: 12px">（次）</div>
                            </div>
                            <div class="left1-bottom1 yi">预警次数</div>
                        </div>
                        <div style="margin-right: 4px">
                            <div style="display: flex; line-height: 20px">
                                <div style="font-size: 20px; margin-left: 5px">
                                    50
                                </div>
                                <div style="font-size: 12px">（次）</div>
                            </div>
                            <div class="left1-bottom1 wei">服务次数</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="title1-right1">
                <div class="title1-right2">
                    <span>房状图展示</span>
                </div>
                <div class="title1-right3">
                    <div
                        v-for="(item, index) in roomList"
                        :key="index"
                        class="title1-list1"
                        :style="{ border: item.bodred }"
                    >
                        <div
                            @click="lookupOld(item)"
                            style="cursor: pointer"
                            class="title1-list2"
                        >
                            <div>
                                <img
                                    src="../assets/bed/woman.png"
                                    alt=""
                                    style="width: 100px; height: 100px"
                                    v-if="
                                        item.photo == null && item.gender == 1
                                    "
                                />
                                <img
                                    src="../assets/bed/man.png"
                                    alt=""
                                    style="width: 100px; height: 100px"
                                    v-if="
                                        item.photo == null && item.gender == 0
                                    "
                                />
                                <img
                                    :src="item.photo"
                                    alt=""
                                    style="width: 100px; height: 100px"
                                    v-if="item.photo != null"
                                />
                            </div>
                            <div>
                                <div style="margin: 5px 0">
                                    <span>姓名：</span>
                                    <span>{{ item.customerName }}</span>
                                </div>
                                <div style="margin: 5px 0">
                                    <span>性别：</span>
                                    <span v-if="item.gender == 0">男</span>
                                    <span v-if="item.gender == 1">女</span>
                                </div>
                                <div style="margin: 5px 0">
                                    <span>年龄：</span>
                                    <span>{{ item.age }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="title1-list4">
                            <div></div>
                            <div class="inner-list4">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                        <div class="title1-list3">
                            <div>
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="防水配件"
                                    placement="bottom-start"
                                >
                                    <img
                                        src="../assets/bed/fspj-yc.png"
                                        alt=""
                                        style="width: 30px; height: 30px"
                                        v-if="item.sosWaterBool == 1"
                                        @click="isSos(item)"
                                    />
                                    <img
                                        src="../assets/bed/fspj.png"
                                        alt=""
                                        style="width: 30px; height: 30px"
                                        v-else
                                    />
                                </el-tooltip>
                            </div>
                            <div>
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="服务铃"
                                    placement="bottom-start"
                                >
                                    <img
                                        src="../assets/bed/fwl-yc.png"
                                        alt=""
                                        style="width: 30px; height: 30px"
                                        v-if="item.bellBool == 1"
                                        @click="isBell(item)"
                                    />
                                    <img
                                        src="../assets/bed/fwl.png"
                                        alt=""
                                        style="width: 30px; height: 30px"
                                        v-else
                                    />
                                </el-tooltip>
                            </div>
                            <div>
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="红外"
                                    placement="bottom-start"
                                >
                                    <img
                                        src="../assets/bed/hw-yc.png"
                                        alt=""
                                        style="width: 30px; height: 30px"
                                        v-if="item.redBool == 1"
                                        @click="isHw(item)"
                                    />
                                    <img
                                        src="../assets/bed/hw.png"
                                        alt=""
                                        style="width: 30px; height: 30px"
                                        v-else
                                    />
                                </el-tooltip>
                            </div>
                            <div>
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="门磁"
                                    placement="bottom-start"
                                >
                                    <img
                                        src="../assets/bed/mc-yc.png"
                                        alt=""
                                        style="width: 30px; height: 30px"
                                        v-if="item.doorBool == 1"
                                        @click="isMc(item)"
                                    />
                                    <img
                                        src="../assets/bed/mc.png"
                                        alt=""
                                        style="width: 30px; height: 30px"
                                        v-else
                                    />
                                </el-tooltip>
                            </div>
                            <div>
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="气感"
                                    placement="bottom-start"
                                >
                                    <img
                                        src="../assets/bed/qgyc.png"
                                        alt=""
                                        style="width: 30px; height: 30px"
                                        v-if="item.qiBool == 1"
                                        @click="isQi(item)"
                                    />
                                    <img
                                        src="../assets/bed/qg.png"
                                        alt=""
                                        style="width: 30px; height: 30px"
                                        v-else
                                    />
                                </el-tooltip>
                            </div>
                            <div>
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="SOS"
                                    placement="bottom-start"
                                >
                                    <img
                                        src="../assets/bed/SOS-yc.png"
                                        alt=""
                                        style="width: 30px; height: 30px"
                                        v-if="item.smokeBoo == 1"
                                        @click="isSmoke(item)"
                                    />
                                    <img
                                        src="../assets/bed/SOS.png"
                                        alt=""
                                        style="width: 30px; height: 30px"
                                        v-else
                                        @click="isSmoke(item)"
                                    />
                                </el-tooltip>
                            </div>
                            <div>
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="烟感"
                                    placement="bottom-start"
                                >
                                    <img
                                        src="../assets/bed/yg-yc.png"
                                        alt=""
                                        style="width: 30px; height: 30px"
                                        v-if="item.smokeBoo == 1"
                                        @click="isSmokeBoo(item)"
                                    />
                                    <img
                                        src="../assets/bed/yg.png"
                                        alt=""
                                        style="width: 30px; height: 30px"
                                        v-else
                                    />
                                </el-tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="title1-left1">
                <div class="title1-left2">
                    <span>服务工单</span>
                </div>
                <div
                    v-for="(item, index) in leftList"
                    :key="index"
                    class="title2-left2"
                >
                    <!-- @click="lookupWork(item)" -->
                    <div style="cursor: pointer" class="title2-list1">
                        <div class="title2-list2" v-if="item.status == 1">
                            <div>{{ item.status == "1" ? "进行中" : "" }}</div>
                            <div>{{ item.status == "2" ? "已结束" : "" }}</div>
                            <div>
                                {{
                                    item.status == null || item.status == "0"
                                        ? "未开始"
                                        : ""
                                }}
                            </div>
                            <div>{{ item.status == 3 ? "已完成" : "" }}</div>
                        </div>
                        <div
                            class="title2-list2 status2"
                            v-if="item.status == 2"
                        >
                            <div>{{ item.status == "1" ? "进行中" : "" }}</div>
                            <div>{{ item.status == "2" ? "已结束" : "" }}</div>
                            <div>
                                {{
                                    item.status == null || item.status == "0"
                                        ? "未开始"
                                        : ""
                                }}
                            </div>
                            <div>{{ item.status == 3 ? "已完成" : "" }}</div>
                        </div>
                        <div
                            class="title2-list2 status4"
                            v-if="item.status == null || item.status == '0'"
                        >
                            <div>{{ item.status == "1" ? "进行中" : "" }}</div>
                            <div>{{ item.status == "2" ? "已结束" : "" }}</div>
                            <div>
                                {{
                                    item.status == null || item.status == "0"
                                        ? "未开始"
                                        : ""
                                }}
                            </div>
                            <div>{{ item.status == 3 ? "已完成" : "" }}</div>
                        </div>
                        <div
                            class="title2-list2 status3"
                            v-if="item.status == 3"
                        >
                            <div>{{ item.status == "1" ? "进行中" : "" }}</div>
                            <div>{{ item.status == "2" ? "已结束" : "" }}</div>
                            <div>
                                {{
                                    item.status == null || item.status == "0"
                                        ? "未开始"
                                        : ""
                                }}
                            </div>
                            <div>{{ item.status == 3 ? "已完成" : "" }}</div>
                        </div>
                        <div class="title2-list3">
                            <div class="title2-list4">
                                <div>
                                    <img
                                        src="../assets/bed/man.png"
                                        alt=""
                                        style="width: 75px; height: 75px"
                                        v-if="
                                            item.photo == null &&
                                            item.gender == 0
                                        "
                                    />
                                    <img
                                        src="../assets/bed/woman.png"
                                        alt=""
                                        style="width: 75px; height: 75px"
                                        v-if="
                                            item.photo == null &&
                                            item.gender == 1
                                        "
                                    />
                                    <img
                                        :src="item.photo"
                                        alt=""
                                        style="width: 75px; height: 75px"
                                        v-if="item.photo != null"
                                    />
                                </div>
                            </div>
                            <div class="title2-list5">
                                <div>工单编号：{{ item.orderNo }}</div>
                                <div style="margin-bottom: 11px">
                                    服务老人：{{ item.customerName }}
                                </div>
                                <div class="address">
                                    家庭地址：{{ item.address }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="left1-center">
            <div class="title1-center1">
                <!-- <div class="serach_wrapper">
          <el-input
            v-model="keyword"
            placeholder="请输入姓名"
            style="width: 120px; margin-right: 12px"
          ></el-input>
          <el-button
            type="primary"
            @click="handleSearch('search')"
          >搜索</el-button>
        </div> -->
                <div class="search-left" style="margin-top: 15px">
                    <el-input placeholder="请输入老人姓名或服务人员查询">
                        <template slot="append">重置</template>
                    </el-input>
                </div>
                <div id="container" style="width: 100%; height: 100%"></div>
                <div class="title1-bottom1">
                    <div class="title1-bottom2">工单统计</div>
                    <div class="title1-bottom3">
                        <div class="orders-container">
                            <div class="orders1">
                                <div>
                                    <span>本年度累计服务工单数</span>
                                    <span class="numbers">1200,000</span>
                                </div>
                                <div>
                                    <span>本年度累计服务工单数</span>
                                    <span class="numbers">1200,000</span>
                                </div>
                                <div>
                                    <span>本年度累计服务工单数</span>
                                    <span class="numbers">1200,000</span>
                                </div>
                                <div>
                                    <span>本年度累计服务工单数</span>
                                    <span class="numbers">1200,000</span>
                                </div>
                            </div>
                            <div class="orders2">
                                <div @click="getAlarmOrderListType(1)">
                                    本月
                                </div>
                                <div @click="getAlarmOrderListType(2)">
                                    上一周
                                </div>
                                <div @click="getAlarmOrderListType(3)">
                                    上一月
                                </div>
                            </div>
                            <div class="orders3">
                                <ul>
                                    <li
                                        v-for="(item, index) in alarmOrderList"
                                        :key="index"
                                        @click="goAlarmOrderDetail(item)"
                                    >
                                        <span class="num">{{ index + 1 }}</span>
                                        <span class="content">
                                            老人【{{ item.userName }}】与【{{
                                                item.eventDesc
                                            }}】触发了【{{
                                                item.eventName
                                            }}】。。。
                                            {{ item.eventTime }}</span
                                        >
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog title="查看" :visible.sync="dialogVisible" width="60%">
            <el-table
                :data="info"
                tooltip-effect="dark"
                style="width: 100%; margin-bottom: 15px"
                :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
                border
            >
                <el-table-column
                    align="center"
                    type="index"
                    label="序号"
                    width="70px"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    align="center"
                    prop="userName"
                    label="用户姓名"
                    min-width="140px"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="userMobile"
                    label="手机号"
                    min-width="140px"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="deviceName"
                    label="设备名称"
                    min-width="140px"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="eventName"
                    label="触发附件名称"
                    min-width="140px"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="eventDesc"
                    label="设备位置"
                    min-width="140px"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="userAddress"
                    label="详细地址"
                    min-width="140px"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
            </el-table>
        </el-dialog>
        <!-- 查看老人应急信息 -->
        <el-dialog
            title="查看"
            :visible.sync="checkOlderInfo"
            width="width"
            class="olderInfo-wrapper"
        >
            <div></div>
            <el-tag> 老人应急信息 </el-tag>
            <el-form ref="form" :inline="true" disabled>
                <ul class="alarmInfo">
                    <li>
                        <el-form-item label="用户姓名：" label-width="110px">
                            <el-input
                                v-model="alarmOrderInfo.userName"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="详细地址：" label-width="110px">
                            <el-input
                                v-model="alarmOrderInfo.userAddress"
                            ></el-input>
                        </el-form-item>
                    </li>
                    <li>
                        <el-form-item label="手机号：" label-width="110px">
                            <el-input
                                v-model="alarmOrderInfo.userMobile"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="设备位置：" label-width="110px">
                            <el-input
                                v-model="alarmOrderInfo.eventDesc"
                            ></el-input>
                        </el-form-item>
                    </li>
                    <li>
                        <el-form-item label="物业联系人：" label-width="110px">
                            <el-input
                                v-model="alarmOrderInfo.propertyContact"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="联系人电话：" label-width="110px">
                            <el-input
                                v-model="alarmOrderInfo.propertyPhone"
                            ></el-input>
                        </el-form-item>
                    </li>
                    <li>
                        <el-form-item label="监护人：" label-width="110px">
                            <el-input
                                v-model="alarmOrderInfo.guardian"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="监护人电话：" label-width="110px">
                            <el-input
                                v-model="alarmOrderInfo.guardianPhone"
                            ></el-input>
                        </el-form-item>
                    </li>
                    <li>
                        <el-form-item label="邻居：" label-width="110px">
                            <el-input
                                v-model="alarmOrderInfo.neighbor"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="邻居电话：" label-width="110px">
                            <el-input
                                v-model="alarmOrderInfo.neighborPhone"
                            ></el-input>
                        </el-form-item>
                    </li>
                    <li>
                        <el-form-item label="兴康助老员：" label-width="110px">
                            <el-input
                                v-model="alarmOrderInfo.elderHelper"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="助老员电话：" label-width="110px">
                            <el-input
                                v-model="alarmOrderInfo.elderHelperPhone"
                            ></el-input>
                        </el-form-item>
                    </li>
                    <li>
                        <el-form-item label="社区监督员：" label-width="110px">
                            <el-input
                                v-model="alarmOrderInfo.supervisor"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="监督员电话：" label-width="110px">
                            <el-input
                                v-model="alarmOrderInfo.supervisorPhone"
                            ></el-input>
                        </el-form-item>
                    </li>
                </ul>
            </el-form>
            <el-tag> 工单处理轨迹 </el-tag>
            <div style="height: 300px" class="orderSteps">
                <el-steps direction="vertical" :active="1">
                    <div
                        v-if="
                            !alarmOrderInfo.handTime &&
                            !alarmOrderInfo.completeTime
                        "
                    >
                        <el-step title="待处置" status="process">
                            <i slot="icon"></i>
                            <div slot="description">
                                <div>{{ alarmOrderInfo.eventTime }}</div>
                                <div>
                                    【{{ alarmOrderInfo.eventDesc }}】已触发
                                </div>
                            </div>
                        </el-step>
                    </div>
                    <div v-if="alarmOrderInfo.handTime">
                        <el-step title="进行中" status="finish">
                            <i slot="icon"></i>
                            <div slot="description">
                                <div>{{ alarmOrderInfo.handTime }}</div>
                                <div>
                                    【{{ alarmOrderInfo.eventDesc }}】已触发
                                </div>
                            </div>
                        </el-step>
                    </div>
                    <div v-if="alarmOrderInfo.completeTime">
                        <el-step title="已完成" status="success">
                            <i slot="icon"></i>
                            <div slot="description">
                                <div>{{ alarmOrderInfo.completeTime }}</div>
                                <div>
                                    【{{ alarmOrderInfo.eventDesc }}】已触发
                                </div>
                            </div>
                        </el-step>
                    </div>
                </el-steps>
            </div>
        </el-dialog>
        <!-- 查看人员详情 -->
        <el-dialog
            title="人员详情"
            :visible.sync="centerDialogVisible"
            width="45%"
            class="person-in-service"
        >
            <div class="container">
                <div class="personInfo-wrapper">
                    <div class="personInfo">
                        <div class="personInfo1">
                            <img src="@/assets/imgs/girl.png" />
                        </div>
                        <div class="personInfo2">
                            <div class="Info1">
                                <span>姓名：张三</span>
                                <span>性别：男</span>
                            </div>
                            <div class="Info2">
                                <span>年龄：33</span>
                                <span>联系电话：13088888888</span>
                            </div>
                            <div class="Info3">
                                地址：安徽省合肥市蜀山区院士大厦
                            </div>
                        </div>
                        <div class="personInfo3">
                            <div>视频通话</div>
                        </div>
                    </div>
                </div>
                <div class="order-container">
                    <div class="orderInfo">
                        <div class="orderInfo1">
                            <div>
                                <span
                                    class="order1"
                                    :class="isActive == 0 ? 'active' : ''"
                                    @click="isActive = 0"
                                    >服务工单</span
                                >
                                <span
                                    class="order1"
                                    :class="isActive == 1 ? 'active' : ''"
                                    @click="isActive = 1"
                                    >应急工单</span
                                >
                                <div class="block">
                                    <el-date-picker
                                        size="mini"
                                        type="dates"
                                        placeholder="选择一个或多个日期"
                                    >
                                    </el-date-picker>
                                </div>
                            </div>
                            <div class="table-wrapper">
                                <table class="pure-table">
                                    <thead>
                                        <tr>
                                            <th>序号</th>
                                            <th>服务名称</th>
                                            <th>老人姓名</th>
                                            <th>开始日期</th>
                                            <th>工单状态</th>
                                            <th>操作</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>上门打扫</td>
                                            <td>张三</td>
                                            <td>2022-3-7 18:22:23</td>
                                            <td class="active">进行中</td>
                                            <td @click="isShowDialog = true">
                                                查看
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>1</td>
                                            <td>上门打扫</td>
                                            <td>张三</td>
                                            <td>2022-3-7 18:22:23</td>
                                            <td>进行中</td>
                                            <td>查看</td>
                                        </tr>

                                        <tr>
                                            <td>1</td>
                                            <td>上门打扫</td>
                                            <td>张三</td>
                                            <td>2022-3-7 18:22:23</td>
                                            <td>进行中</td>
                                            <td>查看</td>
                                        </tr>
                                        <tr>
                                            <td>1</td>
                                            <td>上门打扫</td>
                                            <td>张三</td>
                                            <td>2022-3-7 18:22:23</td>
                                            <td>进行中</td>
                                            <td>查看</td>
                                        </tr>
                                        <tr>
                                            <td>1</td>
                                            <td>上门打扫</td>
                                            <td>张三</td>
                                            <td>2022-3-7 18:22:23</td>
                                            <td>进行中</td>
                                            <td>查看</td>
                                        </tr>
                                        <tr>
                                            <td>1</td>
                                            <td>上门打扫</td>
                                            <td>张三</td>
                                            <td>2022-3-7 18:22:23</td>
                                            <td>进行中</td>
                                            <td>查看</td>
                                        </tr>
                                        <tr>
                                            <td>1</td>
                                            <td>上门打扫</td>
                                            <td>张三</td>
                                            <td>2022-3-7 18:22:23</td>
                                            <td>进行中</td>
                                            <td>查看</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="pages">
                                <el-pagination
                                    small
                                    current-page="1"
                                    :page-sizes="[10, 20, 40, 100]"
                                    :page-size="10"
                                    layout="total, sizes, prev, pager, next"
                                    :total="100"
                                >
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                    <div class="orderForm">
                        <div class="orderForm1">
                            <div>
                                <div
                                    class="chart chart-bar"
                                    ref="chartBar"
                                ></div>
                            </div>
                            <div>
                                <div
                                    class="chart chart-pie"
                                    ref="chartPie"
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>

        <!-- 基本信息、工单信息 -->
        <el-dialog
            title="查看"
            :visible.sync="isShowDialog"
            class="baseInfo-wrapper"
        >
            <el-row class="button-wrapper">
                <el-col :span="11">
                    <el-button type="primary" @click="showForm = 0"
                        >基本信息</el-button
                    >
                </el-col>
                <el-col :span="11">
                    <el-button type="info" @click="showForm = 1"
                        >工单信息</el-button
                    >
                </el-col>
            </el-row>
            <!-- 基本信息 -->
            <el-form v-show="showForm == 0" ref="form" label-width="100px">
                <el-form-item label="老人姓名">
                    <el-input placeholder="测试完整数据1"></el-input>
                </el-form-item>
                <el-form-item label="性别">
                    <el-select placeholder="女" style="width: 100%">
                        <el-option label="男" value="男"></el-option>
                        <el-option label="女" value="女"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="联系方式">
                    <el-input placeholder="13645541212"></el-input>
                </el-form-item>
                <el-form-item label="身份证号">
                    <el-input placeholder="340824198802151444"></el-input>
                </el-form-item>
                <el-form-item label="年龄">
                    <el-input placeholder="33"></el-input>
                </el-form-item>
                <el-form-item label="老人类别">
                    <el-select
                        style="width: 100%"
                        placeholder="建档立卡贫困老人"
                    >
                        <el-option
                            label="建档立卡贫困老人"
                            value="建档立卡贫困老人"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="活动时间">
                    <el-row>
                        <el-select placeholder="河南省">
                            <el-option label="河南省" value=""></el-option>
                        </el-select>
                        <el-select placeholder="洛阳市">
                            <el-option label="洛阳市" value=""></el-option>
                        </el-select>
                        <el-select placeholder="栾川县">
                            <el-option label="栾川县" value=""></el-option>
                        </el-select>
                        <el-select placeholder="9266街道">
                            <el-option label="9266街道" value=""></el-option>
                        </el-select>
                        <el-select placeholder="街道">
                            <el-option label="街道" value=""></el-option>
                        </el-select>
                    </el-row>
                    <el-row>
                        <el-select placeholder="郭寨(公交站)">
                            <el-option label="郭寨公交站" value=""></el-option>
                        </el-select>
                    </el-row>
                </el-form-item>
                <!-- 上传图片 -->
                <el-form-item label="">
                    <el-upload action="" list-type="picture-card">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
            </el-form>
            <!-- 工单信息 -->
            <el-form v-show="showForm == 1" ref="form" label-width="100px">
                <el-form-item label="工单编号">
                    <el-input placeholder="7892738946935"></el-input>
                </el-form-item>
                <el-form-item label="服务名称">
                    <el-input placeholder="家庭照护"></el-input>
                </el-form-item>
                <el-form-item label="服务内容">
                    <el-input type="textarea" rows="2"></el-input>
                </el-form-item>
                <el-form-item label="实际开始时间">
                    <el-time-picker
                        placeholder="选择开始时间"
                        style="width: 100%"
                    ></el-time-picker>
                </el-form-item>
                <el-form-item label="实际结束时间">
                    <el-time-picker
                        placeholder="选择结束时间"
                        style="width: 100%"
                    ></el-time-picker>
                </el-form-item>
                <el-form-item label="服务时常">
                    <el-input placeholder="分钟"></el-input>
                </el-form-item>
                <el-form-item label="服务人员">
                    <el-input placeholder="测试数据"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="isShowDialog = false">取 消</el-button>
                <el-button type="primary" @click="isShowDialog = false"
                    >确 定</el-button
                >
            </div>
        </el-dialog>

        <OldDialog
            ref="business"
            v-if="showOld"
            :oldId="oldId"
            @setOld="setOld"
        ></OldDialog>
        <ServiceDialog
            ref="serviceDialog"
            v-if="showService"
            :serviceId="serviceId"
            @setService="setService"
        ></ServiceDialog>
        <TrainDialog
            ref="zhiyuanzhe"
            v-if="showTrain"
            :trainId="trainId"
            @setTrain="setTrain"
        ></TrainDialog>
        <WorkOrder
            ref="gongdan"
            v-if="showOrder"
            :orderId="oldId"
            @setOrder="setOrder"
        ></WorkOrder>
    </div>
</template>

<script>
import OldDialog from "./components/oldDialog.vue"
import ServiceDialog from "./components/serviceDialog.vue"
import TrainDialog from "./components/trainDialog.vue"
import WorkOrder from "./components/workOrder.vue"
import exportVue from "@/utils/exportVue"
export default {
    components: {
        OldDialog,
        ServiceDialog,
        TrainDialog,
        WorkOrder,
    },
    data() {
        return {
            tatolOldlist: "",
            service: "",
            servising: "",
            keyword: "",
            serviceOrder: "",
            trainPerson: "",
            noTrainPerson: "",
            dialogVisible: false,
            onFullScreen: false,
            roomList: [],
            showOld: false,
            showService: false,
            showTrain: false,
            showOrder: false,
            info: {},
            serviceId: {},
            trainId: {},
            orderId: {},
            leftList: [],
            map: null,
            markers: [],
            findList: [
                {
                    longitude: "116.473083",
                    latitude: "39.993762",
                    path: require("../assets/bed/spotGreen.png"),
                },
                {
                    longitude: "116.182859",
                    latitude: "39.987384",
                    path: require("../assets/bed/spotRed.png"),
                },
            ],
            checkOlderInfo: false,
            centerDialogVisible: false,
            isShowDialog: false,
            showForm: 0,
            isActive: 0,
            alarmOrderList: [],
            alarmCount: 0,
            alarmOrderInfo: {},
        }
    },
    inject: ["reload"],
    created() {
        exportVue.$on("eldlyid", (data) => {
            if (data.isId == true) {
                this.roomList.forEach((item, index) => {
                    if (item.id == data.elderlyId) {
                        this.roomList.splice(index, 1)
                        item.bodred = "2px solid red"
                        this.roomList.unshift(item)
                        this.lookupOld(item)
                        this.$forceUpdate()
                    }
                })
            } else {
                this.map.remove(this.markers)
                this.markers = []
                this.getList()
            }
        })
    },
    async mounted() {
        await this.loadMap().then((res) => {
            this.getList()
            this.getroomList()
            //this.getserviceList()  服务人员
            // this.getpeiList()  培训人员
            this.getFamilyroom()
            this.getService()
            this.getServising()
            this.getServiceOrder()
            this.getTrainPerson()
            this.getnoTrainPerson()
        })
        this.getOlderList()
        // this.renderMapMarker(this.findList)
        this.getAlarmOrderList()

        const self = this
        document.addEventListener(
            "fullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "msfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "mozfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "webkitfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )
    },
    methods: {
        getFirst() {
            this.map.remove(self.marker)
            this.map.remove(self.markers)
            this.marker = []
            this.markers = []
        },
        // 获取应急工单列表
        getAlarmOrderList() {
            this.$http.request({
                    url: "/ypt/admin/eventNotice/info/findListEmergency",
                    method: "POST",
                    data: {
                        pageNo: 1,
                        pageSize: 5,
                        isDeviceCode: 1,
                        startTime: this.startTime,
                        endTime: this.endTime,
                    },
                })
                .then((res) => {
                    console.log(res)
                    if (res.code == 200) {
                        if (res.content && res.content.list) {
                            this.alarmOrderList = res.content.list
                            this.alarmCount = res.content.count
                            console.log(this.alarmCount,"this.alarmCount ");
                        } else {
                            this.alarmOrderList = []
                            this.alarmCount = 0
                        }
                    }
                })
        },
        goAlarmOrderDetail(data) {
            console.log(111, data.id)
            this.$http
                .request({
                    url: "/ypt/admin/eventNotice/info/getEmergency",
                    method: "POST",
                    data: {
                        id: data.id,
                    },
                })
                .then((res) => {
                    console.log(res)
                    if (res.code == 200 && res.content) {
                        this.alarmOrderInfo = res.content
                    } else {
                        this.alarmOrderInfo = {}
                    }
                })
            this.checkOlderInfo = true
        },
        // 获取对应时间段的应急工单
        getAlarmOrderListType(e) {
            let date = new Date()
            let year = date.getFullYear()
            let year_ = year - 1
            let month = date.getMonth() + 1
            let month_ = month - 1
            let day = date.getDate()
            if (month < 10) {
                month = "0" + month
            }
            if (month_ < 10) {
                month_ = "0" + month_
            }

            if (day < 10) {
                day = "0" + day
            }
            if (e == 1) {
                //获取当月的
                this.startTime = ""
                this.endTime = ""
            } else if (e == 2) {
                //获取上周的

                let time = year + "-" + month + "-" + day + " 00:00:00"
                let time2 = new Date().getTime(time) - 7 * 24 * 60 * 60 * 1000
                let date2 = new Date(time2)
                let year_ = date2.getFullYear()
                let month_ = date2.getMonth() + 1
                let day_ = date2.getDate()
                if (month_ < 10) {
                    month_ = "0" + month_
                }

                if (day_ < 10) {
                    day_ = "0" + day_
                }

                this.startTime = year_ + "-" + month_ + "-" + day_ + " 00:00:00"

                this.endTime = year + "-" + month + "-" + day + " 00:00:00"
            } else {
                //获取上月的
                this.startTime = year + "-" + month_ + "-" + "01 00:00:00"

                if (
                    month == 2 ||
                    month == 4 ||
                    month == 6 ||
                    month == 8 ||
                    month == 9 ||
                    month == 11
                ) {
                    this.endTime = year + "-" + month_ + "31 23:59:59"
                } else {
                    this.endTime = year + "-" + month_ + "30 23:59:59"
                }
                if (month == 3) {
                    if (year % 4 == 0) {
                        this.endTime = year + "-" + month_ + "-" + "29 23:59:59"
                    } else {
                        this.endTime = year + "-" + month_ + "-" + "28 23:59:59"
                    }
                }
                if (month == 1) {
                    this.startTime = year_ + "-12-01 23:59:59"
                    this.endTime = year_ + "-12-31 23:59:59"
                }
            }
            this.getAlarmOrderList()
        },
        close() {
            this.dialogVisible = false
        },
        isSos(row) {
            this.dialogVisible = true
            this.$http
                .request({
                    url: "/ypt/admin/eventNotice/info/findList",
                    method: "POST",
                    data: {
                        deviceName: row.equipmentNumber,
                        pageNo: 1,
                        pageSize: -1,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        this.info = res.content.list
                    } else if (res.code == "10004") {
                        this.$message.error(res.message)
                        this.$router.push("/login")
                    }
                })
        },
        isBell() {
            this.dialogVisible = true
            this.$http
                .request({
                    url: "/ypt/admin/eventNotice/info/findList",
                    method: "POST",
                    data: {
                        deviceName: row.equipmentNumber,
                        pageNo: 1,
                        pageSize: -1,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        this.info = res.content.list
                    } else if (res.code == "10004") {
                        this.$message.error(res.message)
                        this.$router.push("/login")
                    }
                })
        },
        isHw(row) {
            this.dialogVisible = true
            this.$http
                .request({
                    url: "/ypt/admin/eventNotice/info/findList",
                    method: "POST",
                    data: {
                        deviceName: row.equipmentNumber,
                        pageNo: 1,
                        pageSize: -1,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        this.info = res.content.list
                    } else if (res.code == "10004") {
                        this.$message.error(res.message)
                        this.$router.push("/login")
                    }
                })
        },
        isMc(row) {
            this.dialogVisible = true
            this.$http
                .request({
                    url: "/ypt/admin/eventNotice/info/findList",
                    method: "POST",
                    data: {
                        deviceName: row.equipmentNumber,
                        pageNo: 1,
                        pageSize: -1,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        this.info = res.content.list
                    } else if (res.code == "10004") {
                        this.$message.error(res.message)
                        this.$router.push("/login")
                    }
                })
        },
        isQi(row) {
            this.dialogVisible = true
            this.$http
                .request({
                    url: "/ypt/admin/eventNotice/info/findList",
                    method: "POST",
                    data: {
                        deviceName: row.equipmentNumber,
                        pageNo: 1,
                        pageSize: -1,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        this.info = res.content.list
                    } else if (res.code == "10004") {
                        this.$message.error(res.message)
                        this.$router.push("/login")
                    }
                })
        },
        isSmoke() {
            this.dialogVisible = true
            this.$http
                .request({
                    url: "/ypt/admin/eventNotice/info/findList",
                    method: "POST",
                    data: {
                        deviceName: row.equipmentNumber,
                        pageNo: 1,
                        pageSize: -1,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        this.info = res.content.list
                    } else if (res.code == "10004") {
                        this.$message.error(res.message)
                        this.$router.push("/login")
                    }
                })
        },
        isSmokeBoo() {
            this.dialogVisible = true
            this.$http
                .request({
                    url: "/ypt/admin/eventNotice/info/findList",
                    method: "POST",
                    data: {
                        deviceName: row.equipmentNumber,
                        pageNo: 1,
                        pageSize: -1,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        this.info = res.content.list
                    } else if (res.code == "10004") {
                        this.$message.error(res.message)
                        this.$router.push("/login")
                    }
                })
        },
        //刷新地图
        refreshMap() {
            this.reload()
        },
        //查找正在服务的人员
        lookupSerPer() {},
        //查找老人工单
        lookupWork(arr) {
            this.map.remove(this.markers)
            this.markers = []
            this.map.remove(this.markers)
            this.markers = []
            let data = Array(arr)
            this.renderMapMarker(data, 5)
        },
        //查找老人
        lookupOld(arr) {
            this.map.remove(this.markers)
            this.markers = []
            this.map.remove(this.markers)
            this.markers = []
            let data = Array(arr)
            this.renderMapMarker(data, 6)
        },
        setOld() {
            this.showOld = false
        },
        setService() {
            this.showService = false
        },
        setTrain() {
            this.showTrain = false
        },
        setOrder() {
            this.showOrder = false
        },
        // 获取房状图展示roomList
        getroomList() {
            this.$http
                .request({
                    url: "/sqyl/admin/bedSet/info/findList",
                    method: "POST",
                    data: {
                        pageSize: -1,
                        pageNo: 1,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        this.getroomList = res.content.list
                    } else if (res.code == "10004") {
                        this.$message.error(res.message)
                        this.$router.push("/login")
                    }
                })
        },
        // 获取老人总数
        getOlderList() {
            this.$http
                .request({
                    url: "/sqyl/admin/elderly/info/findElderlyCount",
                    method: "post",
                    data: {
                        pageSize: -1,
                        pageNo: 1,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        this.tatolOldlist = res.content.total
                    }
                })
        },
        //获取服务人数
        getService() {
            this.$http
                .request({
                    url: "/sqyl/admin/servicePerson/info/findNowServicePesonCount",
                    method: "post",
                    data: {
                        pageSize: -1,
                        pageNo: 1,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        this.service = res.content.total
                    }
                })
        },
        //获取正在服务的服务人员数
        getServising() {
            this.$http
                .request({
                    url: "/sqyl/admin/servicePerson/info/findServicePesonCount",
                    method: "post",
                    data: {
                        pageSize: -1,
                        pageNo: 1,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        this.servising = res.content.total
                    }
                })
        },
        //获取服务工单总数
        getServiceOrder() {
            this.$http
                .request({
                    url: "/sqyl/admin/serviceOrder/info/serviceOrderStatistics",
                    method: "post",
                    data: {
                        pageSize: -1,
                        pageNo: 1,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        this.serviceOrder = res.content.total
                    } else if (res.code == "10004") {
                        this.$message.error(res.message)
                        this.$router.push("/login")
                    }
                })
        },
        //获取查询已参与培训的人数
        getTrainPerson() {
            this.$http
                .request({
                    url: "/sqyl/admin/trainPerson/info/findTrainPersonCount",
                    method: "post",
                    data: {
                        pageSize: -1,
                        pageNo: 1,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        this.trainPerson = res.content.participateInCount
                    }
                })
        },
        //获取未参加培训的人数
        getnoTrainPerson() {
            this.$http
                .request({
                    url: "/sqyl/admin/trainPerson/info/findUnTrainPersonCount",
                    method: "post",
                    data: {
                        pageSize: -1,
                        pageNo: 1,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        this.noTrainPerson = res.content.unParticipateInCount
                    }
                })
        },
        //获取工单
        getFamilyroom() {
            this.$http
                .request({
                    url: "/sqyl/admin/serviceOrder/info/findList",
                    method: "post",
                    data: {
                        pageSize: -1,
                        pageNo: 1,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        res.content.list = res.content.list.filter((item) => {
                            return item.customerName != null
                        })
                        this.leftList = res.content.list
                        let arry = []
                        //	this.markers = []
                        if (res.content.list) {
                            res.content.list.forEach((item, index) => {
                                item.tubiao = require("../assets/img/icon_laoren.png")
                                item.typeId = "gongdan"
                                item.latitude = item.latitude
                                item.longitude = item.longitude
                                if (
                                    item.latitude != null &&
                                    item.longitude != null
                                ) {
                                    arry.push(item)
                                }
                            })

                            // 工单不打点 this.renderMapMarker(arry)
                        }
                    }
                })
        },
        //点击服务老人 又获取全部数据
        getAll() {
            this.getList()
        },
        handleSearch() {
            this.getList()
        },
        // 获取老人数据
        getList() {
            this.$http
                .request({
                    url: "/sqyl/admin/elderly/info/findList1",
                    method: "POST",
                    data: {
                        pageSize: -1,
                        pageNo: 1,
                        customerName: this.keyword,
                    },
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        this.roomList = res.content.list
                        // this.map.remove(this.markers)
                        let arry = []
                        //	this.markers = []
                        this.map.remove(this.markers)
                        this.markers = []
                        if (res.content.list) {
                            res.content.list.forEach((item, index) => {
                                item.tubiao = require("../assets/img/icon_laoren.png")
                                item.typeId = "laoren"
                                item.latitude = item.latitude
                                item.longitude = item.longitude
                                if (
                                    item.latitude != null &&
                                    item.longitude != null
                                ) {
                                    arry.push(item)
                                }
                            })

                            await this.renderMapMarker(arry)
                        }
                        // TODO:
                    } else if (res.code == "10004") {
                        this.$message.error(res.message)
                        this.$router.push("/login")
                    }
                })
        },
        // 获取服务人员数据
        getserviceList(arr) {
            this.$http
                .request({
                    url: "/sqyl/admin/servicePerson/info/findList",
                    method: "POST",
                    data: {
                        pageSize: -1,
                        pageNo: 1,
                    },
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        // this.map.remove(this.markers)
                        if (!arr) {
                            let arry1 = []
                            // this.markers = []
                            if (res.content.list) {
                                res.content.list.forEach((item, index) => {
                                    item.tubiao = require("../assets/img/icon_service.png")
                                    item.typeId = "fuwurenyuan"
                                    item.latitude = item.addressLat
                                    item.longitude = item.addressLng
                                    if (
                                        item.latitude != null &&
                                        item.longitude != null
                                    ) {
                                        arry1.push(item)
                                    }
                                })
                                await this.renderMapMarker(arry1)
                            }
                        } else {
                            let arry1 = []
                            arr.forEach((item, index) => {
                                item.tubiao = require("../assets/img/icon_service.png")
                                item.typeId = "fuwurenyuan"
                                item.latitude = item.addressLat
                                item.longitude = item.addressLng
                                if (
                                    item.latitude != null &&
                                    item.longitude != null
                                ) {
                                    arry1.push(item)
                                }
                            })
                            await this.renderMapMarker(arry1, 7)
                        }

                        // TODO:
                    } else if (res.code == "10004") {
                        this.$message.error(res.message)
                        this.$router.push("/login")
                    }
                })
        },
        // 获取培训人员数据
        getpeiList() {
            this.$http
                .request({
                    url: "/sqyl/admin/train/info/list",
                    method: "POST",
                    data: {
                        pageSize: -1,
                        pageNo: 1,
                    },
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        // this.map.remove(this.markers)
                        let arry2 = []
                        // this.markers = []
                        if (res.content.list) {
                            res.content.list.forEach((item, index) => {
                                item.tubiao = require("../assets/img/icon_peixun.png")
                                item.typeId = "peixun"
                                item.latitude = item.latitude
                                item.longitude = item.longitude
                                if (
                                    item.latitude != null &&
                                    item.longitude != null
                                ) {
                                    arry2.push(item)
                                }
                            })

                            await this.renderMapMarker(arry2)
                        }
                        // TODO:
                    } else if (res.code == "10004") {
                        this.$message.error(res.message)
                        this.$router.push("/login")
                    }
                })
        },
        //地图加载
        loadMap() {
            let self = this
            return new Promise((resolve, reject) => {
                self.map = new AMap.Map("container", {
                    resizeEnable: true,
                    mapStyle: "amap://styles/darkblue",
                    zoom: 9,
                })
                if (
                    this.$store.state.orgAreaLevel == 1 ||
                    this.$store.state.orgAreaLevel == 2 ||
                    this.$store.state.orgAreaLevel == 3
                ) {
                    let cities = [this.$store.state.orgAreaName]
                    for (let i = 0; i < cities.length; i++) {
                        this.areaBG(self.map, cities[i])
                        self.map.setZoom(8)
                    }
                } else if (
                    this.$store.state.orgAreaLevel == 4 ||
                    this.$store.state.orgAreaLevel == 5
                ) {
                    if (this.$store.state.orgId != 0) {
                        this.$http
                            .request({
                                url: "/rbac/admin/org/info/findOrgById",
                                method: "POST",
                                data: {
                                    id: this.$store.state.orgId,
                                },
                            })
                            .then((res) => {
                                var polygonArr = []
                                console.log(
                                    res.content.pointPosition,
                                    "res.content.pointPosition"
                                )
                                res.content.pointPosition
                                    .split(",")
                                    .forEach((i) => {
                                        polygonArr.push(i.split(":"))
                                    })
                                //  console.log(polygonArr, "polygonArr")
                                self.polygon = new AMap.Polygon({
                                    map: self.map,
                                    strokeWeight: 1,
                                    path: polygonArr,
                                    fillOpacity: 0.3,
                                    fillColor: "#2191E6",
                                    strokeColor: "#007CDB",
                                })
                                let maxlng = polygonArr[0].lng
                                for (
                                    let i = 0;
                                    i < polygonArr.length - 1;
                                    i++
                                ) {
                                    maxlng =
                                        maxlng < polygonArr[i + 1].lng
                                            ? polygonArr[i + 1].lng
                                            : maxlng
                                }
                                let minlng = polygonArr[0].lng
                                for (
                                    let i = 0;
                                    i < polygonArr.length - 1;
                                    i++
                                ) {
                                    minlng =
                                        minlng > polygonArr[i + 1].lng
                                            ? polygonArr[i + 1].lng
                                            : minlng
                                }
                                let lngs =
                                    parseInt(minlng) +
                                    (parseInt(maxlng) - parseInt(minlng)) / 2
                                let maxlat = polygonArr[0].lat
                                for (
                                    let i = 0;
                                    i < polygonArr.length - 1;
                                    i++
                                ) {
                                    maxlat =
                                        maxlat < polygonArr[i + 1].lat
                                            ? polygonArr[i + 1].lat
                                            : maxlat
                                }
                                let minlat = polygonArr[0].lat
                                for (
                                    let i = 0;
                                    i < polygonArr.length - 1;
                                    i++
                                ) {
                                    minlat =
                                        minlat > polygonArr[i + 1].lat
                                            ? polygonArr[i + 1].lat
                                            : minlat
                                }
                                let lats =
                                    parseInt(minlat) +
                                    (parseInt(maxlat) - parseInt(minlat)) / 2
                                self.map.setZoomAndCenter(7, [lngs, lats])
                                //self.map.setZoomAndCenter(14,[polygonArr[0].lng, polygonArr[0].lat])
                                self.polygon.setMap(self.map)
                            })
                    }
                }
                resolve()
            })
        },
        areaBG(map, cityName) {
            AMap.service("AMap.DistrictSearch", function () {
                let opts = {
                    subdistrict: 0,
                    extensions: "all",
                    level: "district", // 查询行政级别为市
                }
                // 实例化DistrictSearch
                let district = new AMap.DistrictSearch(opts)
                district.setLevel("district")
                // 行政区查询
                district.search(`${cityName}`, function (status, result) {
                    // 获取边界信息
                    let bounds = result.districtList[0].boundaries
                    let polygons = []
                    if (bounds) {
                        for (let i = 0, l = bounds.length; i < l; i++) {
                            // 生成行政区划polygon
                            let polygon = new AMap.Polygon({
                                map: map,
                                strokeWeight: 1,
                                path: bounds[i],
                                fillOpacity: 0.3,
                                fillColor: "#2191E6",
                                strokeColor: "#007CDB",
                            })
                            polygons.push(polygon)
                        }
                    }
                })
            })
        },
        renderMapMarker(data, zoom) {
            let self = this
            if (data.length) {
                data.forEach((item) => {
                    let marker = new AMap.Marker({
                        position: [
                            item.longitude || item.addressLng,
                            item.latitude || item.addressLat,
                        ],
                        icon: new AMap.Icon({
                            image: item.tubiao,
                            size: new AMap.Size(52, 52), //图标大小
                            imageSize: new AMap.Size(30, 30),
                        }),
                    })

                    self.markers.push(marker)
                    marker.on("mouseover", (e) => {
                        marker.setTitle(item.name)
                    })
                    marker.on("click", (e) => {
                        if (item.typeId == "laoren") {
                            self.oldId = { id: item.id, state: true }
                            //self.showOld = true
                            self.showOrder = true //都改成统一的
                        }
                        if (item.typeId == "gongdan") {
                            self.orderId = { id: item.id, state: true }
                            self.showOrder = true
                        }
                        if (item.typeId == "fuwurenyuan") {
                            self.serviceId = {
                                id: item.servicePersonId || item.id,
                                state: true,
                            }
                            self.showService = true
                        }
                        if (item.typeId == "peixun") {
                            self.trainId = { id: item.id, state: true }
                            self.showTrain = true
                        }
                    })
                })
            }
            self.map.add(self.markers)
            self.map.setFitView(self.markers)
        },
        showFullScreen() {
            this.onFullScreen = !this.onFullScreen
            if (this.onFullScreen) {
                var docElm = document.documentElement
                if (docElm.requestFullscreen) {
                    docElm.requestFullscreen()
                } else if (docElm.msRequestFullscreen) {
                    docElm = document.body //overwrite the element (for IE)
                    docElm.msRequestFullscreen()
                } else if (docElm.mozRequestFullScreen) {
                    docElm.mozRequestFullScreen()
                } else if (docElm.webkitRequestFullScreen) {
                    docElm.webkitRequestFullScreen()
                }
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen()
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen()
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen()
                }
            }
        },
        FullCreeen(element) {
            let el = document.getElementById("bigdata")
            let rfs =
                el.requestFullScreen ||
                el.webkitRequestFullScreen ||
                el.mozRequestFullScreen ||
                el.msRequestFullScreen
            if (typeof rfs != "undefined" && rfs) {
                rfs.call(el)
            } else if (typeof window.ActiveXObject != "undefined") {
                let wscript = new ActiveXObject("WScript.Shell")
                if (wscript != null) {
                    wscript.SendKeys("{F11}")
                }
            }
        },
        showDialog() {
            // console.log('服务中心')
            this.centerDialogVisible = true
            this.$nextTick(() => {
                this.drawLine()
            })
        },
        drawLine() {
            let chartBar = this.$echarts.init(this.$refs.chartBar)
            // console.log('调佣了',chartBar)
            let option1 = {
                title: {
                    text: "工单报表",
                    left: "1%",
                    textStyle: {
                        color: "#4FD3D7",
                    },
                },
                grid: {
                    top: "25%",
                    bottom: "5%",
                    left: "15%",
                    right: "15%",
                },
                color: ["#5470C6", "#91CC75"],
                xAxis: [
                    {
                        type: "category",
                        data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
                        axisPointer: {
                            type: "shadow",
                        },
                    },
                ],
                yAxis: [
                    {
                        type: "value",
                        min: 0,
                        max: 250,
                        interval: 50,
                        axisLabel: {
                            formatter: "{value}",
                            textStyle: {
                                color: "#fff",
                            },
                        },
                    },
                    {
                        type: "value",
                        min: 0,
                        max: 25,
                        interval: 5,
                        axisLabel: {
                            formatter: "{value}",
                            textStyle: {
                                color: "#fff",
                            },
                        },
                    },
                ],
                series: [
                    {
                        name: "Evaporation",
                        type: "bar",
                        tooltip: {
                            valueFormatter: function (value) {
                                return value + " ml"
                            },
                        },
                        data: [
                            2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6,
                            20.0, 6.4, 3.3,
                        ],
                    },
                    {
                        name: "Precipitation",
                        type: "bar",
                        tooltip: {
                            valueFormatter: function (value) {
                                return value + " ml"
                            },
                        },
                        data: [
                            2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7,
                            18.8, 6.0, 2.3,
                        ],
                    },
                    {
                        name: "Temperature",
                        type: "line",
                        yAxisIndex: 1,
                        tooltip: {
                            valueFormatter: function (value) {
                                return value + " °C"
                            },
                        },
                        data: [
                            2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0,
                            16.5, 12.0, 6.2,
                        ],
                    },
                ],
            }
            chartBar.setOption(option1)

            let chartPie = this.$echarts.init(this.$refs.chartPie)
            let option2 = {
                title: {
                    text: "回访统计",
                    left: "1%",
                    textStyle: {
                        color: "#4FD3D7",
                    },
                },
                tooltip: {
                    trigger: "item",
                },
                legend: {
                    top: "14%",
                    left: "center",
                    // data:['优秀','良好','一般','差'],
                    formatter: function (name) {
                        return ""
                    },
                },
                series: [
                    {
                        name: "",
                        type: "pie",
                        radius: ["40%", "70%"],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: "center",
                        },

                        labelLine: {
                            show: false,
                        },
                        center: ["50%", "65%"],
                        data: [
                            { value: 1048, name: "优秀" },
                            { value: 735, name: "良好" },
                            { value: 580, name: "一般" },
                            { value: 484, name: "差" },
                        ],
                    },
                ],
            }
            chartPie.setOption(option2)

            setTimeout(function () {
                window.onresize = function () {
                    chartBar.resize()
                    chartPie.resize()
                }
            }, 200)
        },
    },
}
</script>

<style lang="less" scoped>
// .address {
// width: 100%;
// display: inline-block;
// overflow: hidden;
// text-overflow: ellipsis;
// }
// .address:hover{
//   overflow: visible;
// }
.bigdata_title {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: url("../assets/img/bg.png") no-repeat center center;
    background-size: 100% 100%;
}

.header {
    margin: auto;
    width: 90%;
    height: 10%;
    background: url("../assets/img/bedTop.png") no-repeat center center;
    background-size: 100%;
    h1 {
        color: #23b6e1;
        position: absolute;
        text-align: center;
        // font-weight: bolder;
        font-size: 25px;
        left: 0;
        top: -2px;
        width: 100%;
        height: 78px;
        line-height: 78px;
        z-index: 3;
    }
}
.customerTop {
    margin-bottom: 5px;
    img {
        width: 100%;
        height: 88px;
    }
    h1 {
        color: #c7ebff;
        position: absolute;
        text-align: center;
        // font-weight: bolder;
        font-size: 25px;
        left: 0;
        top: -8px;
        width: 100%;
        height: 78px;
        line-height: 78px;
        z-index: 3;
    }
    .titleFirst {
        min-width: 560px;
        position: absolute;
        width: 560px;
        // border-top: 78px solid #1e69b6;
        border-left: 40px solid transparent;
        border-right: 40px solid transparent;
        height: 0;
        left: 50%;
        top: 0;
        margin-left: -310px;
        z-index: 2;
    }
    .titleSecond {
        min-width: 620px;
        width: 620px;
        position: absolute;
        // border-top: 78px solid #103b71;
        border-left: 40px solid transparent;
        border-right: 40px solid transparent;
        height: 0;
        left: 50%;
        top: 0;
        margin-left: -340px;
    }
}
.quanp {
    width: 200px;
    height: 100px;
    // float: right;
    position: absolute;
    top: 20px;
    right: -110px;
    z-index: 99;
    button {
        padding: 10px;
    }
}
.quanpL {
    width: 200px;
    height: 100px;
    // float: left;
    position: absolute;
    top: 20px;
    left: 10px;
    button {
        padding: 10px;
    }
}
.content1 {
    width: 54%;
    margin: 0 auto;
    display: flex;
}

.content1-title {
    width: 100%;
    display: flex;
}

.title-left1 {
    width: 25%;
    margin-right: 3%;
    height: 16vh;
    color: #ffffff;
}

.left1-title1-1 {
    width: 100%;
    height: 8vh;
    line-height: 7vh;
    font-size: 14px;
    text-align: center;
}

.left1-title1-2 {
    width: 100%;
    display: flex;
    height: 20px;
    line-height: 20px;
    text-align: center;
    justify-content: center;
}

.left1-title1-21 {
    width: 100%;
    display: flex;
    text-align: center;
    justify-content: space-around;
}

.left1-bottom1 {
    margin-top: 20%;
    width: 100%;
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    background: #064a70;
    border-radius: 2px;
    color: #e4e4e4;
    padding: 2px 4px;
}
.serviceing {
    background: #706532;
}
.yi {
    background: #004257;
}
.wei {
    background: #007fa7;
}
.img1 {
    background: url("../assets/bed/top1.png") no-repeat center center;
    background-size: 100%;
}

.img2 {
    background: url("../assets/bed/top2.png") no-repeat center center;
    background-size: 100%;
}

.img3 {
    background: url("../assets/bed/top3.png") no-repeat center center;
    background-size: 100%;
}

.img4 {
    background: url("../assets/bed/top4.png") no-repeat center center;
    background-size: 100%;
    margin-right: 0;
}

.title1-right1 {
    width: 22%;
    height: 88%;
    overflow: hidden;
    overflow: auto;
    position: absolute;
    top: 10.5%;
    right: 0;
    font-size: 14px;
    border: 1px solid #00b3eb;
    border-radius: 8px;
}

.title1-right2 {
    width: 92%;
    margin: 0 auto;
    position: absolute;
    height: 5%;
    top: 3%;
    left: 3%;
    background: url("../assets/bed/lrtotal.png") no-repeat center center;
    background-size: 100%;
    display: flex;
    justify-content: flex-center;
    align-items: center;
    span {
        color: #00b3eb;
        font-size: 24px;
        margin-bottom: 32px;
        display: inline-block;
        text-align: center;
        width: 100%;
    }
}

.title1-right3 {
    width: 92%;
    margin: 0 auto;
    position: absolute;
    color: #fff;
    top: 9%;
    left: 3%;
}
.title1-list1 {
    width: 100%;
    // height: 100%;
    border: 2px solid #1b5fb7;
    padding: 10px 0;
    margin-bottom: 1%;
}

.title1-list2 {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 1%;
}
.title1-list2 > div:first-child {
    margin-right: 20px;
}

.title1-list3 {
    width: 90%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
}

.title1-list4 {
    width: 100%;
}

.title1-list4 > div:first-child {
    width: 84%;
    margin: 0 auto;
    height: 1px;
    background-color: #134582;
}

.inner-list4 {
    width: 84%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}

.inner-list4 > div {
    width: 1px;
    height: 10px;
    background-color: #134582;
}

.title1-bottom1 {
    height: 33%;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 99%;
    margin: 0 auto;
    z-index: 1;
    .title1-bottom2 {
        color: #fff;
        margin: 10px;
    }
    .title1-bottom3 {
        border: 1px solid #00b3eb;
        border-radius: 8px;
        color: #fff;
        padding: 5px 0;
        .orders-container {
            display: flex;
            width: 95%;
            margin: 0 auto;
            // border: 1px solid red;
            height: 170px;
            .orders1 {
                flex: 5;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-around;
                align-content: space-around;
                margin-right: 10px;
                div {
                    width: 40%;
                    height: 50px;
                    border: 1px solid #ccc;
                    text-align: center;
                    padding-top: 8px;
                    font-size: 12px;
                    line-height: 1.5;
                    .numbers {
                        font-size: 14px;
                        font-weight: bold;
                    }
                }
            }
            .orders2 {
                flex: 0.5;
                border-left: 1px solid #fff;
                padding-left: 20px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                div {
                    width: 20px;
                    height: 28%;
                    font-size: 12px;
                    background-color: #fff;
                    color: black;
                    text-align: center;
                    writing-mode: vertical-lr;
                    padding-left: 3px;
                    cursor: pointer;
                }
            }
            .orders3 {
                flex: 6;
                font-size: 12px;
                ul {
                    flex-direction: column;
                    justify-content: space-between;
                    /* border: 1px solid; */
                    margin-left: 16px;
                    // padding: 10px 0;
                    li {
                        height: 34px;
                        display: flex;
                        align-items: center;
                        overflow: hidden;
                        // border: 1px solid #ccc;
                        .num {
                            display: inline-block;
                            width: 35px;
                            height: 20px;
                            line-height: 20px;
                            text-align: center;
                            background-color: #fff;
                            color: black;
                            margin-right: 10px;
                        }
                        .content {
                            border-bottom: 1px solid #fff;
                            padding-left: 15px;
                        }
                        .content:hover {
                            color: #00b3eb;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
}

.left1-center {
    width: 54%;
    height: 71%;
    margin-left: 23%;
    margin-top: 0.5%;
    position: relative;
    display: flex;
    justify-content: space-between;
    border: 1px solid #00b3eb;
    border-radius: 2px;
}

.title1-left1 {
    width: 22%;
    height: 88%;
    overflow: hidden;
    font-size: 12px;
    overflow-y: auto;
    background-size: 100%;
    position: absolute;
    top: 10.5%;
    left: 0;
    border: 1px solid #00b3eb;
    border-radius: 8px;
}

.title1-center1 {
    width: 100%;
}

.title1-left2 {
    width: 90%;
    margin: 5% auto;
    margin-bottom: 0;
    height: 7%;
    background: url("../assets/bed/lrtotal.png") no-repeat center center;
    background-size: 100%;
    display: flex;
    justify-content: flex-center;
    align-items: center;
    span {
        color: #00b3eb;
        font-size: 24px;
        margin-bottom: 32px;
        display: inline-block;
        text-align: center;
        width: 100%;
    }
}

.title1-left2 > div:first-child {
    margin-right: 2%;
}

.title2-left2 {
    width: 94%;
    margin: 0 auto;
    color: #ffffff;
    background: #064a70;
    border-radius: 4px;
}

.title2-list1 {
    width: 93%;
    margin-bottom: 12px;
    position: relative;
    padding: 17px 17px 15px 10px;
    border-radius: 4px;
}

.title2-list2 {
    width: 0;
    height: 0;
    border: 60px solid #000000;
    border-color: transparent transparent transparent #7c7a2d;
    transform: rotate(-45deg);
    position: absolute;
    right: -14.8%;
    top: -52%;
}
.status2 {
    //已结束
    border-color: transparent transparent transparent rgb(10, 42, 53);
    background-color: rgb(6, 74, 112);
}
.status3 {
    //已完成
    border-color: transparent transparent transparent #007fa7;
}
.status4 {
    border-color: transparent transparent transparent #6d0e0e;
}
.title2-list2 > div {
    position: absolute;
    left: -60px;
    top: -10px;
    transform: rotate(90deg);
}

.title2-list3 {
    width: 100%;
    margin: 0px auto;
    display: flex;
    align-items: center;
}

.title2-list4 {
    width: 20.8%;
}

.title2-list4 > div:nth-child(2) {
    margin-top: 10px;
}

.title2-list5 {
    width: 70%;
    // white-space: nowrap;
    // display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    margin-top: -5px;
    margin-left: 12px;
}

.title2-list5 > div:first-child {
    margin-bottom: 10px;
}
.map_container1 {
    width: 80%;
    margin-left: 140px;
    margin-bottom: 20px;
}
/deep/ .serach_wrapper {
    z-index: 100;
    position: absolute;
    left: 50%;
    top: 10px;
    transform: translateX(-50%);
    .el-button {
        color: #0291c2;
        background: #041d4d;
        border: none;
    }
    .el-input__inner {
        color: #0291c2;
        background: #102132;
        border-color: #233b87;
    }
}
/deep/ .search-left {
    width: 26%;
    position: absolute;
    left: 2%;
    top: 2%;
    z-index: 1;
    .el-input-group {
        opacity: 0.8;
        font-size: 10px;
    }
    .el-input__inner {
        height: 28px;
    }
    .el-input-group__append {
        padding: 0 4px;
    }
}
/deep/ .olderInfo-wrapper {
    .el-dialog {
        width: 47%;
    }
    .el-tag {
        margin-bottom: 10px;
    }
    .el-input__inner {
        width: 250px;
        padding: 0;
        height: 28px;
    }
    .el-form-item__label {
        font-size: 16px;
    }
    .el-form--inline {
        margin-bottom: 10px;
    }
    .el-form--inline .el-form-item {
        margin-left: 40px;
        margin-bottom: 0 !important;
    }
}
.orderSteps {
    margin: 15px 0 15px 155px;
}
/deep/ .person-in-service {
    .el-dialog {
        background-color: #0a246a;
        .el-dialog__header {
            background-color: #024e88;
            padding: 5px 22px;
            height: 43px;
            line-height: 43px;
            .el-dialog__headerbtn .el-dialog__close {
                color: #fff;
            }
            .el-dialog__title {
                color: #fff;
            }
        }
    }
    .container {
        display: flex;
        flex-direction: column;
        .personInfo-wrapper {
            padding: 20px;
            box-shadow: 0 0 25px #2b81b7 inset;
            margin-bottom: 15px;
            .personInfo {
                background-color: #0a246a;
                display: flex;
                padding: 0 20px;
                .personInfo1 {
                    flex: 2;
                    img {
                        width: 80px;
                        height: 80px;
                    }
                }
                .personInfo2 {
                    flex: 6;
                    display: flex;
                    flex-direction: column;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    color: #41eaec;
                    .Info1 span {
                        margin-right: 55px;
                    }
                    .Info2 span {
                        margin-right: 67px;
                    }
                }
                .personInfo3 {
                    flex: 2;
                    position: relative;
                    div {
                        width: 100px;
                        height: 50px;
                        border-radius: 8px;
                        background-color: #169bd5;
                        color: #fff;
                        text-align: center;
                        line-height: 50px;
                        position: absolute;
                        top: 0;
                        bottom: 0;
                        margin: auto 0;
                    }
                }
            }
        }
        .order-container {
            display: flex;
            .orderInfo {
                flex: 6;
                padding: 20px;
                box-shadow: 0 0 25px #2b81b7 inset;
                margin-bottom: 15px;
                margin-right: 15px;
                color: #fff;
                .orderInfo1 {
                    background-color: #0a246a;
                    position: relative;
                    height: 100%;
                    .block {
                        position: absolute;
                        top: 0;
                        right: 4%;
                        .el-date-editor.el-input {
                            width: 90%;
                        }
                    }

                    span {
                        padding: 2px 5px;
                    }
                    .order1 {
                        background-color: #fff;
                        color: black;
                        display: inline-block;
                        height: 20px;
                        line-height: 20px;
                        width: 70px;
                        text-align: center;
                        margin: 0 5px;
                    }
                    .order1.active {
                        background-color: #169bd5;
                        color: #fff;
                    }
                    .table-wrapper {
                        margin: 25px 0;
                        height: 75%;
                        overflow: auto;
                        .pure-table {
                            text-align: center;
                            thead {
                                height: 30px;
                            }
                            .active {
                                color: red;
                            }
                            tbody td {
                                border-bottom: 1px solid #cbcbcb;
                                width: 72px;
                            }
                        }
                    }
                }
            }
            .orderForm {
                flex: 4;
                padding: 20px;
                box-shadow: 0 0 25px #2b81b7 inset;
                margin-bottom: 15px;
                .orderForm1 {
                    background-color: #0a246a;
                    color: #fff;
                    .chart {
                        width: 300px;
                        height: 190px;
                        margin: 0 auto;
                    }
                }
            }
        }
    }
}
</style>
<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.el-pagination {
    margin-top: 15px !important;
}
.el-pagination .el-select .el-input .el-input__inner {
    height: 22px !important;
}
.person-in-service .container .order-container .orderInfo .orderInfo1 span {
    padding: 0 !important;
}
.el-step.is-vertical .el-step__title {
    margin-left: -100px;
    position: absolute;
    top: -1px;
}
.el-step__description {
    font-size: 16px;
}
.el-step.is-vertical {
    flex-basis: 20%;
}
.olderInfo-wrapper .el-dialog,
.baseInfo-wrapper .el-dialog {
    border-radius: 8px;
}
.olderInfo-wrapper .el-dialog .el-dialog__header,
.baseInfo-wrapper .el-dialog .el-dialog__header {
    border-bottom: 1px solid;
    padding: 15px 0 12px 15px;
}
.olderInfo-wrapper .el-dialog .el-dialog__body,
.baseInfo-wrapper .el-dialog .el-dialog__body {
    padding: 8px 20px;
}
.baseInfo-wrapper .el-dialog {
    width: 61%;
}
.baseInfo-wrapper .el-dialog .el-col-11 {
    text-align: center;
    padding-bottom: 10px;
}
.el-input__inner {
    text-indent: 8px;
}
.alarmInfo li {
    width: 100%;
    display: flex;
    justify-content: space-around;
}
.alarmInfo li .el-form-item {
    width: 45% !important;
}
</style>
